import { useDispatch, useSelector } from 'react-redux'

import { AppDispatch, RootState } from 'redux/store'
import { clearAllFilters, setSearch } from 'redux/ui/meetingsUI'

import PageHeading from 'components/atoms/PageHeading'
import MainTableFiltersForm from 'components/organisms/forms/tableFilters/MainTableFiltersForm'
import MainTable from 'components/organisms/tables/MainTable'

import formModel, { initialValues } from 'utils/tableFilterModels/meetingsTableFilterModel'
import { useTableModel } from 'utils/tableModels/useMeetingsTableModel'

import ExtraFiltersMeetings from 'components/organisms/forms/tableFilters/meetings/ExtraFilters'
import { useTranslation } from 'react-i18next'
import { meetingsAPI, useGET_meetingsQuery } from 'redux/api/meetingsApi'
import { useEffect } from 'react'
import BoxTitle from 'components/atoms/BoxTitle'
import { MeetingRoom } from '@mui/icons-material'

const MeetingsPage = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const reduxKey = 'meetings'

  const activeFilters = useSelector((state: RootState) => state[reduxKey].activeFilters)
  const filters = {
    creator: useSelector((state: RootState) => state[reduxKey].tableFilters.creator),
    start_date_from: useSelector((state: RootState) => state[reduxKey].tableFilters.start_date_from),
    start_date_to: useSelector((state: RootState) => state[reduxKey].tableFilters.start_date_to),
    status: useSelector((state: RootState) => state[reduxKey].tableFilters.status),
    student: useSelector((state: RootState) => state[reduxKey].tableFilters.student),
    category: useSelector((state: RootState) => state[reduxKey].tableFilters.category),
  }

  useEffect(() => { 
    dispatch(clearAllFilters())
  }, [])
  
  return (
    <>
      <div style={{ padding: '20px', paddingBottom: '0px' }}><BoxTitle title={t('common.meetings')} icon={<MeetingRoom />} /></div>

      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_meetingsQuery}
        filters={filters}
        header={
          <MainTableFiltersForm
            reduxKey={reduxKey}
            tag="meetings"
            entityName={t('common.meetings')}
            addLabel={t('common.add-meeting')}
            api={meetingsAPI}
            setSearch={setSearch}
            clearAllFilters={clearAllFilters}
            formModel={formModel}
            initialValues={initialValues}
            activeFilters={activeFilters}
            baseUrl={'/meetings/'}
          >
            <ExtraFiltersMeetings />
          </MainTableFiltersForm>
        }
      />
    </>
  )
}
export default MeetingsPage
